import SendMail from './send-mail'

import withRedux from './with-redux'

export default withRedux(SendMail)
